import api from "../../../../api/flexapi";
export const GET_BENEFIT_PERIOD_BEGIN = "GET_BENEFIT_PERIOD_BEGIN";
export const GET_BENEFIT_PERIOD_SUCCESS = "GET_BENEFIT_PERIOD_SUCCESS";
export const GET_BENEFIT_PERIOD_ERROR = "GET_BENEFIT_PERIOD_ERROR";

export const GET_TOTAL_REWARDS_STATEMENT_BEGIN = "GET_TOTAL_REWARDS_STATEMENT_BEGIN";
export const GET_TOTAL_REWARDS_STATEMENT_SUCCESS = "GET_TOTAL_REWARDS_STATEMENT_SUCCESS";
export const GET_TOTAL_REWARDS_STATEMENT_ERROR = "GET_TOTAL_REWARDS_STATEMENT_ERROR";

export const getTrsBenefitPeriodList = () => {
  return dispatch => {
    dispatch({ type: GET_BENEFIT_PERIOD_BEGIN, payload: null });
    api
      .getTrsBenefitPeriodList()
      .then(res => {
        dispatch({
          type: GET_BENEFIT_PERIOD_SUCCESS,
          payload: res.body,
        });
      })
      .catch(err => {
        dispatch({
          type: GET_BENEFIT_PERIOD_ERROR,
          payload: err.response ? err.response.body : err,
        });
      });
  };
};

export const getTrsDetail = benefitPeriod => dispatch => {
  dispatch({ type: GET_TOTAL_REWARDS_STATEMENT_BEGIN, payload: null });
  api
    .getTrsDetail(benefitPeriod)
    .then(res => {
      dispatch({
        type: GET_TOTAL_REWARDS_STATEMENT_SUCCESS,
        payload: res.body,
      });
    })
    .catch(err => {
      dispatch({
        type: GET_TOTAL_REWARDS_STATEMENT_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};



// WEBPACK FOOTER //
// ./components/employee/benefits/trs/actions.js